import { SidebarItem } from '@backstage/core-components';
import HistoryIcon from '@material-ui/icons/History';
import { useReleasesAccess } from './useReleases';

/** Solo aparece para devops y arquitectos. */
export const ReleasesSidebarItem = () => (useReleasesAccess() ? <SidebarItem icon={HistoryIcon} to="releases" text="Releases" /> : null);
